var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.tooltip,
          expression: "tooltip"
        }
      ],
      staticClass: "recommendation",
      attrs: { tabindex: "0" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.navigate($event)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.navigate($event)
        }
      }
    },
    [
      _c("div", {
        staticClass: "thumbnail",
        style: { "background-image": "url(" + _vm.previewUrl + ")" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        _c(
          "div",
          { staticClass: "file-name" },
          [
            _vm.extension
              ? [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.nameWithoutExtension))
                  ]),
                  _vm.extension
                    ? _c("span", { staticClass: "extension" }, [
                        _vm._v("." + _vm._s(_vm.extension))
                      ])
                    : _vm._e()
                ]
              : [
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.name))
                  ])
                ]
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "reason" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.reason) + "\n\t\t")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }